module.exports = __webpack_public_path__ + "static/img/荣誉_02@2x.637de085.png";